class CountryPick {
	constructor() {
		this._init()
	}
	_init() {
		this.documentCountryISO = document.querySelector('meta[name=country]').content.split(',')[0].split('=')[1]
		document.querySelectorAll('[data-country-pick]').forEach(el => new CountryPickOption(el, this))
	}
}

class CountryPickOption {
	constructor(el, countryPicker) {
		this.el = el
		this.countryPicker = countryPicker
		this._init()
	}
	_init() {
		this.elContent = this.el.querySelector('[data-country-pick-content]')
		document.querySelectorAll('[data-country-pick-option]').forEach((el) => {
			el.addEventListener('click', () => {
				this.change(el)
			})
		})
	}
	change(el) {
		const elCountryISO = el.dataset.countryPickOption

		if (elCountryISO == this.countryPicker.documentCountryISO)
			return

		const url = window.location.href
		const newUrl = url.split(`/${this.countryPicker.documentCountryISO}/`).join(`/${elCountryISO}/`)
		window.location.href = newUrl
	}
}

export default CountryPick